import React from 'react';
import { LoginBox } from './components/LoginBox';
import { getLoginUrl } from '../../utils';

export function Login() {
  return (
    <LoginBox loginUrl={getLoginUrl()} />
  );
}
